import { render, staticRenderFns } from "./BuildBank.vue?vue&type=template&id=f4b29f36&"
import script from "./BuildBank.vue?vue&type=script&lang=js&"
export * from "./BuildBank.vue?vue&type=script&lang=js&"
import style0 from "./BuildBank.vue?vue&type=style&index=0&id=f4b29f36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports